export default __webpack_public_path__ + "static/media/szujscy.5eb5f241.jpeg";